import React from "react"
import { Router, Route, Switch, Link, NavLink, Redirect } from "react-router-dom"
//import createHistory from 'history/createBrowserHistory';
import { createBrowserHistory } from "history"
import ExpenseDashboardPage from "../components/ExpenseDashboardPage"
import AddExpensePage from "../components/AddExpensePage"
import EditExpensePage from "../components/EditExpensePage"
import CopyExpensePage from "../components/CopyExpensePage"
import HelpPage from "../components/HelpPage"
import NotFoundPage from "../components/NotFoundPage"
import ExpenseLoginPage from "../components/ExpenseLoginPage"
import PrivateRoute from "./PrivateRoute"
import PublicRoute from "./PublicRoute"
import NewsPage from "../components/NewsPage"
import UploadPage from "../components/UploadPage"
//import Join from '../components/Chat/Join/Join'
//import Chat from '../components/Chat/Chat/Chat'

export const history = createBrowserHistory()

const AppRouter = () => (
  <Router history={history}>
    <div>
      <Switch>
        <PublicRoute path="/" component={ExpenseLoginPage} exact={true} />
        <PrivateRoute path="/create" component={AddExpensePage} />
        <PrivateRoute path="/dashboard" component={ExpenseDashboardPage} />
        <PrivateRoute path="/edit/:id" component={EditExpensePage} />
        <PrivateRoute path="/copy/:id" component={CopyExpensePage} />
        {/* <PrivateRoute path="/Join" component={Join} exact={true} />
        <PrivateRoute path="/Chat" component={Chat} exact={true} /> */}
        {/* <Redirect from='/news/' to="/" /> */}
        <PrivateRoute path="/news" component={NewsPage} exact={true} />
        <PrivateRoute path="/upload" component={UploadPage} exact={true} />

        <Route component={NotFoundPage} />
      </Switch>
    </div>
  </Router>
)

export default AppRouter



// WEBPACK FOOTER //
// ./src/routers/AppRouter.js